import React, { useState, useEffect } from "react";
import { CardBody, Card, Row, Col } from "reactstrap";
import { AGENCY_DETAILS_URL } from "../../../../utils/APIEndpoints";
import { authHeader } from "../../../../utils/functions/CoreFunctions";
import API from "../../../../redux/actions/API";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getAlertToast,
  getDateString,
} from "../../../../utils/functions/CustomFunctions";
import CustomLoader from "../../../common/CustomLoader";
import defaultAvatar from "../../../../assets/images/defaultImages/defaultAvatar.png";
import { Table } from "reactstrap";
const Details = (props) => {
  const [agencyData, setAgencyData] = useState([]);
  const [codeListDetails, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  //Get Agency Data
  const getAgencyData = async (params) => {
    setLoading(true);
    const options = {
      method: "GET",
      url: AGENCY_DETAILS_URL,
      headers: authHeader(),
      params: params,
    };
    try {
      const response = await API(options);
      const { status, agency, locationCodeDetails } = response.data;
      if (status === "Success") {
        setAgencyData(agency);
        setDetails(locationCodeDetails);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  let { id } = useParams();
  //Did Mount
  useEffect(() => {
    getAgencyData({ agencyId: parseInt(id) });
  }, []);

  return (
    <Card>
      <CardBody className="details">
        <Row>
          <Col sm="12" md={{ size: 6, offset: 3 }}>
            <center>{loading && <CustomLoader loading={loading} />}</center>

            <div>
              <div className="imgUpload" style={{ marginBottom: "0.5rem" }}>
                <img
                alt="uploaded"
                  className="uploadImg"
                  src={agencyData.agencyLogo || defaultAvatar}
                  width={100}
                  height={100}
                />
              </div>
              <center>
                <span style={{ color: "#48465b", fontWeight: "700" }}>
                  Agency Logo
                </span>
              </center>
            </div>
            <div className="kt-widget__content">
              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Account Holder Name:</span>
                <span className="kt-widget__data">
                  {agencyData.accountHolderName || "N/A"}
                </span>
              </div>
              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Account Number: </span>
                <span className="kt-widget__data">
                  {agencyData.accountNumber || "N/A"}
                </span>
              </div>
              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Agency Name:</span>
                <span className="kt-widget__data">
                  {agencyData.companyName || "N/A"}
                </span>
              </div>
              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Agency Email:</span>
                <span className="kt-widget__data">
                  {agencyData.agencyEmail || "N/A"}
                </span>
              </div>
              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Agency Phone Number:</span>
                <span className="kt-widget__data">
                  (+1) {agencyData.agencyPhone || "N/A"}
                </span>
              </div>
              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Agency Address:</span>
                <span className="kt-widget__data">
                  {agencyData.agencyAddress || "N/A"}
                </span>
              </div>
              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Bank Address:</span>
                <span className="kt-widget__data">
                  {agencyData.bankAddress || "N/A"}
                </span>
              </div>

              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Created Date:</span>
                <span className="kt-widget__data">
                  {getDateString(agencyData.createdDate) || "N/A"}
                </span>
              </div>

              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Created By:</span>
                <span className="kt-widget__data">
                  {agencyData.createdName || "N/A"}
                </span>
              </div>

              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Routing Number:</span>
                <span className="kt-widget__data">
                  {agencyData.ifscCode || "N/A"}
                </span>
              </div>

              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Tax ID:</span>
                <span className="kt-widget__data">
                  {agencyData.taxId || "N/A"}
                </span>
              </div>

              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Auto Approval:</span>
                <span className="kt-widget__data">
                  {agencyData.autoApproval ? "YES" : "NO" || "N/A"}
                </span>
              </div>

              <div className="kt-widget__info mb-2">
                <span className="kt-widget__label">Verification Document:</span>
                <span className="kt-widget__data">
                  <a href={agencyData.verificationDocument} target="_blank">
                    {" "}
                    <i
                      className="far fa-file"
                      style={{
                        marginLeft: "9px",
                        fontSize: "17px",
                        color: "#18bb0e",
                      }}
                    ></i>
                  </a>
                </span>
              </div>
              <div
                className=""
                style={{ backgroundColor: "#F7F7F7", padding: "10px" }}
              >
                {/* <h5 style={{ fontSize: "16px" }}>Location Code(s):</h5> */}
                <div>
                  <Table striped>
                    <thead>
                      <tr>
                        <th>Location Code</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      {codeListDetails &&
                        codeListDetails.map(
                          ({ locationCode, description }, index) => (
                            <tr key={`code_${index}`}>
                              <td>
                                <b>{locationCode}</b>
                              </td>
                              <td>{description}</td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default Details;
